import { Checkbox, Input } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import type { ChangeEvent } from "react";
import { useState } from "react";
import type { Horizon } from "@/store/geo-test/types";
import { values } from "../constants";

import type { HorizonContactsProps } from "../interfaces";

import styles from "../styles/styles.module.css";

interface HorizonItemProps {
	checkBoxesValues: CheckboxValueType[];
	horizon: Horizon;
	checked?: boolean;
	setSelectedHorizon: React.Dispatch<React.SetStateAction<Horizon[]>>;
	selectedHorizon: Horizon[];
	index: number;
	min: number;
	max: number;
}
const HorizonItem = ({
	horizon,
	setSelectedHorizon,
	checkBoxesValues,
	index,
	min,
	max,
}: HorizonItemProps) => {
	const onDepthChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
		const newDepth = Number(e.target.value);

		setSelectedHorizon((prevState) => {
			const updatedHorizon = [...prevState];
			updatedHorizon[index] = {
				...updatedHorizon[index],
				depth: newDepth,
			};
			return updatedHorizon;
		});
	};

	const handleChecked = (e: CheckboxChangeEvent) => {
		setSelectedHorizon((prevHorizons: Horizon[]) =>
			prevHorizons.map((h) =>
				h.value === e.target.value ? { ...h, checked: e.target.checked } : h,
			),
		);
	};

	return (
		<div className={`${styles.customContainer} flex w-full !px-4`}>
			<div className="customContainer flex items-center !space-x-4">
				<Checkbox
					className="!mt-5"
					checked={horizon.checked}
					onChange={handleChecked}
					name={horizon.value.toString()}
					value={horizon.value}
				/>
				<div className="flex flex-col" id="DCRangePicker">
					<label className="!text-black dark:!text-gray-1400 !mb-1" title="Название набора скважин">
						{horizon.label}
					</label>
					<Input
						type="number"
						style={{ width: "100px" }}
						name={horizon.label}
						min={min}
						max={max}
						value={horizon.depth === 0 ? "" : horizon.depth}
						disabled={!checkBoxesValues.some((v) => v === horizon.value)}
						onChange={(e) => onDepthChange(e, index)}
					/>
				</div>
			</div>
		</div>
	);
};

export const HorizonContacts = ({
	setSelectedHorizon,
	selectedHorizon,
}: HorizonContactsProps) => {
	const [indeterminate, setIndeterminate] = useState(false);
	const [checkAll, setCheckAll] = useState(false);
	const [checkBoxesValues, setCheckBoxesValues] = useState<CheckboxValueType[]>(
		[],
	);
	const handleChange = (checkedValues: CheckboxValueType[]) => {
		setCheckBoxesValues(checkedValues);
		setIndeterminate(!!checkedValues.length);
		setCheckAll(checkedValues.length === checkBoxesValues.length);
	};

	const onCheckAllChange = (event: CheckboxChangeEvent) => {
		const { checked } = event.target;
		setCheckBoxesValues(checked ? values : []);
		setIndeterminate(false);
		setCheckAll(checked);
	};

	return (
		<div className="!font-normal !flex !flex-col">
			<div className="!mt-2 !flex h-[33px] flex-shrink-0 items-center !px-4 ">
				<Checkbox
					className="reports-checkbox items-center"
					indeterminate={indeterminate}
					onChange={onCheckAllChange}
					checked={checkAll}
				>
					<span className="text-black dark:text-font-tertiary">
						(Выделить всё)
					</span>
				</Checkbox>
			</div>

			<div className="!overflow-y-auto">
				<Checkbox.Group
					className="w-full"
					value={checkBoxesValues}
					onChange={handleChange}
				>
					{selectedHorizon.map((horizon: Horizon, i: number) => {
						const min = i === 0 ? 0 : selectedHorizon[0].depth;
						const max = i === 0 ? selectedHorizon[1].depth : Infinity;
						return (
							<HorizonItem
								key={`key-${horizon.label}`}
								horizon={horizon}
								setSelectedHorizon={setSelectedHorizon}
								selectedHorizon={selectedHorizon}
								checkBoxesValues={checkBoxesValues}
								index={i}
								min={min}
								max={max}
							/>
						);
					})}
				</Checkbox.Group>
			</div>
		</div>
	);
};
